module.exports = __webpack_public_path__ + "images/external_images/img/200x200/img1.jpg";